/* global Alpine */

document.addEventListener('alpine:init', bootstrap);

export default (index) => ({
	index,
	lightbox(markup) {
		Alpine.store('lightbox').toggle();
		Alpine.store('lightbox').markup = markup;
	}
});

function bootstrap() {
	bootstrapStore();
	bootstrapDom();
}

function bootstrapStore() {
	Alpine.store('lightbox', {
		show: false,
		markup: '',
		toggle() {
			this.show = !this.show;
		}
	});
}

function bootstrapDom() {
	const $body = document.querySelector('body');
	if ( !$body ) { return; }

	$body.insertAdjacentHTML(
		'afterbegin',
		`
<div
	style="display: none;"
	x-data
	x-show="$store.lightbox.show"
	class="opportunity-lightbox"
	x-trap.noscroll.inert="$store.lightbox.show"
>
<a href="#" class="opportunity-lightbox--close" x-on:click.away="$store.lightbox.show = false"><span>Close</span></a>
	<div
		x-html="$store.lightbox.markup"
		x-on:click.away="$store.lightbox.show = false"
	>
	</div>
</div>
		`
	);
}
